import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay, ease: EASE }}>
    {children}
  </motion.div>
);

export const SectionHead = ({ index, kicker, title, children }) => (
  <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-5 md:gap-8 mb-8 md:mb-12">
    <Reveal>
      <p className="font-mono text-xs tracking-[0.35em] text-[#F5A524] mb-3 md:mb-4">// {index} — {kicker}</p>
      <h2 className="font-display font-black uppercase text-[2.75rem] sm:text-7xl lg:text-8xl leading-[0.85] tracking-tight">{title}</h2>
    </Reveal>
    {children && <Reveal delay={0.15}>{children}</Reveal>}
  </div>
);
